__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "truck-it-new";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.10.0", () => (Promise.all([__webpack_require__.e(832), __webpack_require__.e(188), __webpack_require__.e(527)]).then(() => (() => (__webpack_require__(44832))))));
			register("@material-ui/core", "4.9.0", () => (Promise.all([__webpack_require__.e(841), __webpack_require__.e(754), __webpack_require__.e(417), __webpack_require__.e(527), __webpack_require__.e(929), __webpack_require__.e(221)]).then(() => (() => (__webpack_require__(38417))))));
			register("@material-ui/styles", "4.11.5", () => (Promise.all([__webpack_require__.e(333), __webpack_require__.e(527), __webpack_require__.e(936)]).then(() => (() => (__webpack_require__(69333))))));
			register("@mui/x-date-pickers", "9.6.0", () => (Promise.all([__webpack_require__.e(841), __webpack_require__.e(899), __webpack_require__.e(505), __webpack_require__.e(527), __webpack_require__.e(929)]).then(() => (() => (__webpack_require__(51899))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(527)]).then(() => (() => (__webpack_require__(40961))))));
			register("react", "18.2.0", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(91703);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};